export const subscribe = function (scope, events, selectorOrListener, listener) {
    if (typeof selectorOrListener === "string") {
        scope.on(events, selectorOrListener, listener);
        return {
            off: () => scope.off(events, selectorOrListener, listener),
        };
    }
    else {
        scope.on(events, selectorOrListener);
        return {
            off: () => scope.off(events, selectorOrListener),
        };
    }
};
export const once = function (scope, events, selectorOrListener, listener) {
    const wrapper = function (t, ...args) {
        scope.off(events, wrapper);
        return typeof selectorOrListener === "string"
            ? listener.apply(this, [t, ...args])
            : selectorOrListener.apply(this, [t, ...args]);
    };
    if (typeof selectorOrListener === "string") {
        scope.on(events, selectorOrListener, wrapper);
        return {
            off: () => scope.off(events, selectorOrListener, wrapper),
        };
    }
    else {
        scope.on(events, wrapper);
        return {
            off: () => scope.off(events, wrapper),
        };
    }
};
